import { render } from "./slide6.vue?vue&type=template&id=03f9d5b0&scoped=true"
import script from "./slide6.vue?vue&type=script&lang=js"
export * from "./slide6.vue?vue&type=script&lang=js"

import "./slide6.vue?vue&type=style&index=0&id=03f9d5b0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f9d5b0"]])

export default __exports__